import { render, staticRenderFns } from "./EIMZOCert.vue?vue&type=template&id=153fac2d&"
import script from "./EIMZOCert.vue?vue&type=script&lang=js&"
export * from "./EIMZOCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports